exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialogContent {\n  margin: 0px; }\n\n.emailChip {\n  margin-top: 10px;\n  padding: 4px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/confirm-dialog/confirm-dialog.component.scss
// module id = ../../../../../src/app/main/content/apps/e-commerce/solutionForm/confirm-dialog/confirm-dialog.component.scss
// module chunks = main